var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "b-tooltip",
          rawName: "v-b-tooltip.hover.viewport",
          modifiers: { hover: true, viewport: true },
        },
      ],
      staticClass: "d-flex align-items-center",
      attrs: { title: "Mirror moves & resizes across every template" },
    },
    [
      _c(
        "b-form-checkbox",
        {
          staticClass: "sync-layout-toggle",
          class: { "is-active": _vm.isSyncOn },
          on: { change: _vm.onChange },
          model: {
            value: _vm.isSyncOn,
            callback: function ($$v) {
              _vm.isSyncOn = $$v
            },
            expression: "isSyncOn",
          },
        },
        [
          _c(
            "svg",
            {
              attrs: {
                width: "14",
                height: "14",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "aria-hidden": "true",
              },
            },
            [
              _c("path", { attrs: { d: "M8 3 4 7l4 4" } }),
              _vm._v(" "),
              _c("path", { attrs: { d: "M4 7h16" } }),
              _vm._v(" "),
              _c("path", { attrs: { d: "m16 21 4-4-4-4" } }),
              _vm._v(" "),
              _c("path", { attrs: { d: "M20 17H4" } }),
            ]
          ),
          _vm._v(" "),
          _c("span", [_vm._v("Sync Templates")]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }